import React from 'react';
import ProjectContainer from './ProjectContainer';
import universityContent from '../Content/UniversityContent';
import EditorChrome from './EditorChrome';

class University extends React.Component
{
    render ()
    {
        return (
            <main className="container portfolio-shell inner-shell">
                <EditorChrome active="/Archive" />
                <section className="inner-editor archive-index-page University">
                            <a className="back-link" href="/">Back home</a>
                            <h1>University Project Archive</h1>
                            <p className="archive-intro">
                                Earlier software, embedded, and engineering coursework. These projects are kept as a
                                technical archive while the homepage now focuses on current PhD research and applied work.
                            </p>
                            <ProjectContainer projectTiles={universityContent}/>
                </section>
            </main>
        );
    }
}

export default University;
